module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-kursseite-black-sale-en-fd1817b4356e903adf6b756a38653edd.jpg";